import { useQuery } from '@apollo/client';

import GET_COURSE_ENROLLMENT_PROGRESS from '../graphql/GetCourseEnrollmentProgressQuery.graphql';
import type {
  GetCourseEnrollmentProgressQuery,
  GetCourseEnrollmentProgressQueryVariables,
} from '../graphql/types/GetCourseEnrollmentProgressQuery';
import type { TDataSlice } from '../types';

const useGetCourseEnrollment = () => {
  const { data, loading, refetch } = useQuery<
    GetCourseEnrollmentProgressQuery,
    GetCourseEnrollmentProgressQueryVariables
  >(GET_COURSE_ENROLLMENT_PROGRESS, {
    variables: {
      first: 1,
      lastActions: true,
      isHidden: false,
      isActive: true,
      assignedCourses: null,
      progressState: 'progress',
    },
  });

  if (data?.me?.enrollmentSet?.totalCount === 0) {
    refetch({ progressState: 'incomplete' });
  }

  const courseSlide: TDataSlice[] | undefined =
    data?.me?.enrollmentSet?.edges.flatMap(elem => {
      const enrollment = elem?.node;
      const course = enrollment?.course;

      // The enrollment is the row, so its own id is the identity. An edge
      // without one cannot be told apart from another, and a stringified
      // absence would collide with every other id-less row.
      if (!enrollment?.originalId) {
        return [];
      }

      return {
        id: String(enrollment.originalId),
        imagePlaceholder: course?.imagePlaceholder,
        isEnrollment: true,
        promoImage: course?.promoImage,
        lastVideoLectureUrl: course?.lastVideoLectureUrl,
        title: course?.title || '',
        duration: course?.duration,
        progress: course?.progress,
        teacher: course?.professor?.fullName,
        dashboardUrl: course?.dashboardUrl,
        url: course?.url,
      } satisfies TDataSlice;
    });

  return { courseSlide, loadingCourseEnrollmentProgress: loading };
};

export default useGetCourseEnrollment;
